import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-the-template-i" }
const _hoisted_2 = { class: "p-the-template-i__inner" }
const _hoisted_3 = { class: "p-the-template-i__header" }
const _hoisted_4 = { class: "p-the-template-i__body" }
const _hoisted_5 = { class: "p-the-template-i__body__inner" }
const _hoisted_6 = {
  key: 0,
  class: "p-the-template-i__body__header"
}
const _hoisted_7 = {
  key: 1,
  class: "p-the-template-i__right-col"
}
const _hoisted_8 = {
  key: 0,
  class: "p-the-template-i__shown-search-form-button"
}
const _hoisted_9 = {
  key: 1,
  class: "p-the-template-i__sorted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheBreadcrumb = _resolveComponent("TheBreadcrumb")!
  const _component_CommonHeading = _resolveComponent("CommonHeading")!
  const _component_FormSearch = _resolveComponent("FormSearch")!
  const _component_ButtonRefineBase = _resolveComponent("ButtonRefineBase")!
  const _component_ButtonRefine = _resolveComponent("ButtonRefine")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TheBreadcrumb),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          (_ctx.heading)
            ? (_openBlock(), _createBlock(_component_CommonHeading, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.heading), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (
              _ctx.indicateSearchForm || _ctx.indicateSearchButton || _ctx.indicateSortedButton
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_ctx.indicateSearchForm)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["p-the-template-i__search", _ctx.executeSearchFormDomAnimation ? _ctx.searchFormClassName : '']),
                      style: _normalizeStyle(_ctx.executeSearchFormDomAnimation ? (_ctx.shownSearchFormState ? {} : _ctx.serchFormStyle) : {}),
                      ref: "searchFormElement"
                    }, [
                      _createVNode(_component_FormSearch, {
                        search: _ctx.search,
                        "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                        onDoSearch: _ctx.doSearch,
                        placeholder: _ctx.searchPlaceholder
                      }, null, 8, ["search", "onDoSearch", "placeholder"])
                    ], 6))
                  : _createCommentVNode("", true),
                (_ctx.indicateSearchButton || _ctx.indicateSortedButton)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (_ctx.indicateSearchButton)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("button", {
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.switchSearchFormState && _ctx.switchSearchFormState(...args))),
                              class: "p-the-template-i__shown-search-form-button__button"
                            }, [
                              _createVNode(_component_ButtonRefineBase, null, {
                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                  _createTextVNode("検索", -1)
                                ])),
                                _: 1,
                                __: [4]
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.indicateSortedButton)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_ButtonRefine, {
                              heading: _ctx.filterHeading,
                              icon: "sorted",
                              "refine-item-list": _ctx.sorted.itemList,
                              refine: _ctx.sorted.target,
                              "onUpdate:refine": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sorted.target) = $event)),
                              shown: _ctx.sorted.shownState,
                              onDoSort: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doSort($event))),
                              onSwitchRefineState: _ctx.switchSortedState,
                              width: _ctx.widthButtonRefine
                            }, null, 8, ["heading", "refine-item-list", "refine", "shown", "onSwitchRefineState", "width"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "p-the-template-i__body__content",
            style: _normalizeStyle(_ctx.contentElementStyle),
            ref: "contentElement"
          }, [
            _renderSlot(_ctx.$slots, "contents", {}, undefined, true)
          ], 4)
        ])
      ])
    ])
  ]))
}